import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72467285"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add", -1))
const _hoisted_3 = { class: "mt-4 table table-hover" }
const _hoisted_4 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  colspan: "5",
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_11 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('closingPeriods'),
        "help-text": _ctx.$t('closingPeriodCreateDescription'),
        mb: 1
      }, {
        buttons: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              class: "btn btn-hover icon-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {this.$router.push({name: 'new-closing-period'});})
            }, [
              _hoisted_2,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('new')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "help-text"]),
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('name')), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('begin')), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('end')), 1),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!_ctx.isReady)
            ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                key: 0,
                "n-cols": 5
              }))
            : (_ctx.closingPeriods.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('noClosingPeriodsFound')), 1)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.closingPeriods, (closingPeriod) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "align-middle",
                    key: closingPeriod.name
                  }, [
                    _createElementVNode("td", null, _toDisplayString(closingPeriod.name), 1),
                    _createElementVNode("td", null, _toDisplayString(this.formatDateString(closingPeriod.begin)), 1),
                    _createElementVNode("td", null, _toDisplayString(this.formatDateString(closingPeriod.end)), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        class: "btn btn-icon btn-primary ms-2",
                        to: {name: 'edit-closing-period', params: { id: closingPeriod.id}}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.deleteClosingPeriod(closingPeriod.id)),
                        class: "btn btn-icon btn-danger ms-2"
                      }, _hoisted_15, 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}